import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import SvgTrustPilotStar from '../../images/trustpilot-star.inline.svg'
import SvgTrustPilotStarEmpty from '../../images/trustpilot-star-empty.inline.svg'
import SvgTrustPilotStarQuarter from '../../images/trustpilot-star-quarter.inline.svg'
import SvgTrustPilotStarHalf from '../../images/trustpilot-star-half.inline.svg'
import SvgTrustPilotStarThreeQuarters from '../../images/trustpilot-star-three-quarters.inline.svg'

interface Props {
  rating: number
  boxClass?: string
  iconClass?: string
}

const TrustPilotStarRating: React.FC<Props> = ({
  rating,
  boxClass,
  iconClass,
}) => {
  const { classes, cx } = useStyles()

  const starRating = (ratingValue: number) => {
    let boundedRating = 0

    if (rating > 5) {
      boundedRating = 5
    } else if (rating > 0) {
      boundedRating = ratingValue
    }

    const stars = []

    for (let i = 0; i < Math.floor(boundedRating); i++) {
      stars.push(<SvgTrustPilotStar className={cx(classes.icon, iconClass)} />)
    }

    if (boundedRating % 1 > 0) {
      const quarterStars = Math.floor((boundedRating % 1) / 0.25)

      switch (quarterStars) {
        case 0:
          stars.push(
            <SvgTrustPilotStarEmpty className={cx(classes.icon, iconClass)} />
          )
          break
        case 1:
          stars.push(
            <SvgTrustPilotStarQuarter className={cx(classes.icon, iconClass)} />
          )
          break
        case 2:
          stars.push(
            <SvgTrustPilotStarHalf className={cx(classes.icon, iconClass)} />
          )
          break
        case 3:
          stars.push(
            <SvgTrustPilotStarThreeQuarters
              className={cx(classes.icon, iconClass)}
            />
          )
          break
      }
    }

    for (let i = 0; i < 5 - Math.ceil(boundedRating); i++) {
      stars.push(
        <SvgTrustPilotStarEmpty className={cx(classes.icon, iconClass)} />
      )
    }
    return stars
  }

  return (
    <Box className={boxClass}>{starRating(rating).map((star) => star)}</Box>
  )
}

const useStyles = makeStyles()(() => ({
  icon: {
    height: '1.34rem',
    width: 'auto',
  },
}))

export default TrustPilotStarRating
